import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import { FiArrowUpRight, FiCreditCard } from "react-icons/fi";
import siteConfig from "../siteConfig";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-about">
          <p className="footer-eyebrow">ABOUT</p>
          <h2>The {siteConfig.brandName} Story</h2>
          <p>{siteConfig.description}</p>
          <Link to="/about" onClick={toTop}>
            learn more... <FiArrowUpRight />
          </Link>
        </div>
        <div className="footer-payment">
          <h2>SECURE PAYMENT</h2>
          <p>Checkout is completed through our encrypted payment partner.</p>
          <div
            className="payment-methods"
            aria-label="Supported payment methods"
          >
            <span>
              <FiCreditCard /> Visa
            </span>
            <span>Mastercard</span>
            <span>American Express</span>
          </div>
        </div>
        <div className="footer-visit">
          <h2>CONTACT BENTOMARKET</h2>
          <p>{siteConfig.contact.email}</p>
          <p>{siteConfig.contact.company}</p>
          <p>{siteConfig.contact.address}</p>
          <Link to="/contact" onClick={toTop}>
            Contact support <FiArrowUpRight />
          </Link>
        </div>
      </div>
      <div className="footer-bottom">
        <nav aria-label="Footer navigation">
          <Link to="/returns" onClick={toTop}>
            RETURNS / FAQ
          </Link>
          <Link to="/about" onClick={toTop}>
            ABOUT
          </Link>
          <Link to="/contact" onClick={toTop}>
            CONTACT
          </Link>
          <Link to="/shipping" onClick={toTop}>
            SHIPPING
          </Link>
          <Link to="/terms" onClick={toTop}>
            TERMS
          </Link>
          <Link to="/privacy" onClick={toTop}>
            PRIVACY
          </Link>
          <Link to="/cookies" onClick={toTop}>
            COOKIES
          </Link>
          <Link to="/faqs" onClick={toTop}>
            FAQS
          </Link>
          <Link to="/accessibility" onClick={toTop}>
            ACCESSIBILITY
          </Link>
        </nav>
        <div className="footer-meta">
          <span>
            © {new Date().getFullYear()} {siteConfig.brandName}
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
